// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"ce00d23d","354":"892140df","420":"f22fa5c3","450":"4b6d8ef3","539":"6523970f","644":"57c55bba","775":"cd75b432","857":"9365ea11","884":"ff270439","945":"825e6dec"}[chunkId] + ".js";
};